import { makeStyles } from '@mui/styles';
import TextField from 'apollo-react/components/TextField';
import React, { useEffect, useState } from 'react';

import { getUITA } from '../../../../../utils/commonUtils';

const useStyles = makeStyles({
  root: {
    marginTop: 0,
  },
});

export const ErrorMessageTextField = ({ ruleId, errorMsg, setErrorMsgValue }) => {
  const classes = useStyles();
  const [value, setValue] = useState(errorMsg ?? '');

  useEffect(() => {
    setValue(errorMsg ?? '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ruleId]);

  return (
    <TextField
      size="small"
      ui-ta={getUITA('Rule Message')}
      className={classes.root}
      fullWidth
      onBlur={() => {
        setErrorMsgValue(value);
      }}
      label="Message"
      value={value}
      onChange={({ target }) => setValue(target.value)}
      sizeAdjustable
      minWidth={400}
      minHeight={100}
    />
  );
};
